import React, { createContext, useContext } from 'react';

interface LayoutContextType {
  hasSharedSidebar: boolean;
}

const LayoutContext = createContext<LayoutContextType>({
  hasSharedSidebar: false,
});

export const useLayout = () => useContext(LayoutContext);

export const LayoutProvider: React.FC<{ children: React.ReactNode; hasSharedSidebar?: boolean }> = ({ 
  children, 
  hasSharedSidebar = true 
}) => {
  return (
    <LayoutContext.Provider value={{ hasSharedSidebar }}>
      {children}
    </LayoutContext.Provider>
  );
};

